import { RoutePageType } from "@routes/interfaces"
import Modulo from "./pages/Modulo"

const modulosPages: RoutePageType[] = [
    { key: 'modulo', element: Modulo }
]

export default modulosPages